import React from 'react';
import {
  shallowEqual,
  TypedUseSelectorHook,
  useSelector as useReduxSelector,
} from 'react-redux';

import {
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

import { RootState } from '../../../app/rootReducer';
import { Resource } from '../../../common/constants/resource';
import { IAutomatedEvidence } from './interfaces/IAutomatedEvidence';

export const useSelector: TypedUseSelectorHook<RootState> = useReduxSelector;

const formatData = (automatedEvidences: IAutomatedEvidence[]) => {
  const tableData = automatedEvidences.map(automatedEvidence => {
    return {
      evidenceType: automatedEvidence.evidenceType,
      key: automatedEvidence.key,
    };
  });
  return tableData;
};

export const AutomatedEvidence = ({
  getAutomatedEvidenceUrl,
}: {
  getAutomatedEvidenceUrl: any;
}) => {
  const {
    automatedEvidences,
  }: {
    automatedEvidences: IAutomatedEvidence[];
  } = useSelector((state: RootState) => {
    return {
      automatedEvidences: state.automatedEvidence.automatedEvidences,
    };
  }, shallowEqual);

  if (!automatedEvidences || automatedEvidences.length === 0) {
    return <></>;
  }

  const data = formatData(automatedEvidences);

  return (
    <Box data-section-id={'Automated evidence table'}>
      <Typography gutterBottom variant="h2">
        {Resource.AUTOMATED_EVIDENCE_TITLE}
      </Typography>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="auto-evidence-table">
          <TableHead>
            <TableRow>
              <TableCell>Evidence Type</TableCell>
              <TableCell>File</TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map(row => (
              <TableRow key={row.key}>
                <TableCell>{row.evidenceType}</TableCell>
                <TableCell>{row.key}</TableCell>
                <TableCell onClick={() => getAutomatedEvidenceUrl(row.key)}>
                  <Button color="primary" variant="contained" disableElevation>
                    <Typography noWrap variant="subtitle2">
                      Download
                    </Typography>
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};
